import { getCountTaskDebugBySpaces, getFormProjectInfo, getFormProjectTeam, getReasonPause } from "../../../../config";
import { truncateNumber } from "../../../../helpers/operationMath";
import { structureCategoriesForm, structureCategoriesForProject } from "../../../../helpers/projectHelper";
import { statusProjectType } from "../../../../types/statusProject";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";


const getExtraPropsHrsProject = async ({ projectDetails, auth }) => {
    const { calculatedHours } = projectDetails;
    const { development, planning } = calculatedHours;
    const { web, unity, modeling, design, testing = 0 } = development;

    return {
        dataForm: {
            developing: development.total,
            web: web,
            unity: unity,
            design: design,
            modeling: modeling,
            planning: planning,
            isTracing: projectDetails.size === "F",
            testing: truncateNumber(testing),
        },
        isSuperAdmin: auth.isSuperAdmin,
    };
};

const fetchProjectInfo = async () => {
    const { status, payload } = await getFormProjectInfo();
    if (status > 0) throw new Error("Failed to fetch project info");
    return payload;
};

// Datos por defecto del proyecto
const defaultProjectData = {
    description: "",
    properties: { maintenance: false, hardware: false, metaverso: false },
    platforms: [],
    categories: [],
};

const structureForm = (data, payload) => {
    const categoriesObj = structureCategoriesForProject(payload.categories);

    const categories = structureCategoriesForm(data.categories);

    return {
        selectForm: {
            plataforms: payload.platforms,
            categories: categoriesObj,
        },
        dataForm: {
            description: data.description,
            platformNames: data.platforms.map((platform) => platform.name),
            properties: data.properties,
            categorie: categories,
        },
    };
};

// Función principal para obtener los detalles del proyecto
const getProjectDetails = async (data = defaultProjectData) => {
    const payload = await fetchProjectInfo();
    return structureForm(data, payload);
};

const getExtraPropsProjectData = async ({ projectDetails }) => {
    const { description, platforms, properties, categories } = projectDetails;

    const { selectForm, dataForm } = await getProjectDetails({
        description,
        platforms,
        properties,
        categories,
    });

    return {
        dataForm: dataForm,
        platforms: selectForm.plataforms,
        categories: selectForm.categories,
    };
};


const getReasonPausesBySelect = async () => {
    const { status: statusPausesReason, payload } = await getReasonPause();
    let reasonPauses = [];
    if (statusPausesReason === 0) {
        reasonPauses = payload;
    }
    return reasonPauses;
};

const getExtraPropsCalendar = async ({ projectDetails }) => {
    const reasonPause = await getReasonPausesBySelect();

    const { expected, deadLine } = projectDetails.dates;
    const form = { estimatedClosingDate: expected ? expected : "", deadLineDate: deadLine ? deadLine : "" };

    return {
        dataForm: form,
        reasons: reasonPause,
        pauses: projectDetails.pauses,
        isActivePauses: projectDetails.status === statusProjectType.pause,
    };
};

const getExtraPropsPauses = async ({ projectDetails }) => {
    const reasonPause = await getReasonPausesBySelect();
    const emptyCloseObjects = projectDetails.pauses.find((obj) => obj.close === "");
    const idPause = !emptyCloseObjects ?
        { id: -1, date: "", reasons: [] } :
        { id: emptyCloseObjects._id, date: emptyCloseObjects.init, reasons: emptyCloseObjects.reasons };
    return {
        pauseSelect: idPause,
        reasons: reasonPause,
    };
};

const getExtraPropsExtraTime = async ({ projectDetails }) => {
    const {
        status: stsTeams,
        payload: {
            payload: userTeam
        },
    } = await getFormProjectTeam();

    if (stsTeams > 0) return { users: [] }

    const valuesBack = {
        desing: "design",
        unity: "unity",
        web: "web",
        art3d: "modeling"
    }

    const getNamesUsers = Object
        .entries(valuesBack)
        .reduce((prev, [key, value]) => {
            const valueUsers = userTeam[value]
            if (!valueUsers) return prev
            return {
                [key]: valueUsers,
                ...prev
            }
        }, {})

    return { users: getNamesUsers }
};

const getExtraPropsConcluedProject = ({ projectDetails, auth }) => ({
    isProjectRed: projectDetails.isProjectRed,
    project: projectDetails,
    auth: auth
});

const getExtraPropsClient = ({ projectDetails }) => ({
    dataForm: projectDetails.client,
});

const getExtraPropsProjectRed = ({ projectDetails }) => ({
    dataForm: projectDetails.overtimecomments,
});

const getExtraPropsViewConclued = ({ projectDetails }) => ({
    dataForm: projectDetails.retrospective,
    isProjectRed: projectDetails.hasOverTime,
    commentCancel: projectDetails.projectCancelcomments,
});

const getTaskCountDebug = async ({ projectDetails }) => {
    const { payload } = await getCountTaskDebugBySpaces(projectDetails.clickupSpace);
    return {
        taskList: payload.taskcount.correctList,
    };
};

const propsExtraByTypeModal = {
    [typeForDetailsProyect.hrsProjectDetails]: getExtraPropsHrsProject,
    [typeForDetailsProyect.client]: getExtraPropsClient,
    [typeForDetailsProyect.hrsExtraTime]: getExtraPropsExtraTime,

    [typeForDetailsProyect.calendar]: getExtraPropsCalendar,
    [typeForDetailsProyect.pauses]: getExtraPropsPauses,

    [typeForDetailsProyect.concluedProject]: getExtraPropsConcluedProject,
    [typeForDetailsProyect.projectRed]: getExtraPropsProjectRed,
    [typeForDetailsProyect.viewConcluedProject]: getExtraPropsViewConclued,

    [typeForDetailsProyect.projects]: getExtraPropsProjectData,

    [typeForDetailsProyect.modalDebugTaskCount]: getTaskCountDebug,
};

const getPropsDataByModalSelect = async ({ type, projectDetails, auth }) => {
    console.log(type);

    let selectedPropsExtraResponse;
    try {
        selectedPropsExtraResponse = await propsExtraByTypeModal[type]({ projectDetails, auth });
    } catch (error) {
        selectedPropsExtraResponse = {};
    }

    return selectedPropsExtraResponse;
};

export { getPropsDataByModalSelect };
